import type { FieldValues, Path, UseFormReturn } from 'react-hook-form';
import { Controller } from 'react-hook-form';

import type { SelectOption } from '@/components/ui/select';
import { DetailsSelect } from '@/features/estates-property/components/details-select';

export const FieldSelect = <T extends FieldValues>({
  label,
  name,
  methods,
  options = [],
  required = true,
  type = 'string',
}: {
  name: Path<T>;
  label: string;
  required?: boolean;
  methods: UseFormReturn<T>;
  options?: SelectOption[];
  type?: 'string' | 'number';
}) => {
  return (
    <Controller
      {...methods}
      name={name}
      render={({ field: { onChange, value, ...field }, fieldState }) => (
        <DetailsSelect
          {...field}
          label={`${label}${required ? '*' : ''}`}
          value={String(value)}
          options={options}
          className="shadow-sm"
          onChange={(ev) => {
            if (type === 'number') {
              onChange(Number(ev.target.value));
            } else {
              onChange(ev.target.value);
            }
          }}
          errors={fieldState.error?.message ? [fieldState.error.message] : undefined}
        />
      )}
    />
  );
};
